import { all, fork } from 'redux-saga/effects'
import API from '../services/sagaApi'

// Import Sagas
import authSaga from './AuthSagas'
import scriptSaga from './ScriptSagas'
import audioSaga from './AudioSagas'
import videoSaga from './VideoSagas'
import thumbnailSaga from './ThumbnailSagas'
import draftSaga from './DraftSagas'
import voiceSaga from './VoiceSagas'
import soundEffectSaga from './SoundEffectSagas'
import startupSaga from './StartupSagas'
import creditSaga from './CreditSagas'
import plansSaga from './PlansSagas'
import subtitleSaga from './SubtitleSagas'
import publicationSaga from './PublicationSagas'

// Create API instance for sagas
const api = API.create()

// Root Saga
export default function* root() {
  yield all([
    fork(startupSaga, api),
    fork(authSaga, api),
    fork(scriptSaga, api),
    fork(audioSaga, api),
    fork(videoSaga, api),
    fork(thumbnailSaga, api),
    fork(draftSaga, api),
    fork(voiceSaga, api),
    fork(soundEffectSaga, api),
    fork(creditSaga, api),
    fork(plansSaga, api),
    fork(subtitleSaga, api),
    fork(publicationSaga, api),
  ])
}

// Export API instance for direct use if needed
export { api }
